import { resendEmailActivation } from './resend-email';
import { slackWebhookActivation } from './slack-webhook';
import type { IntegrationActivation } from './types';

export const activationRegistry: Record<string, IntegrationActivation> = {
  slack_webhook: slackWebhookActivation,
  resend: resendEmailActivation,
};

export function getActivation(type: string): IntegrationActivation | undefined {
  return activationRegistry[type];
}
